module.exports = __webpack_public_path__ + "static/fonts/Oswald-BoldItalic.987b52c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/formats/font/Oswald-BoldItalic.ttf
// module id = Wx3Z
// module chunks = 1